import videojs from "video.js";
import 'videojs-flvjs-es6'

const videos = document.getElementsByTagName('video');
if (videos) {
    for (let el of videos) {
        if (!el.classList.contains('video-js')) {
            el.classList.add('video-js');
            el.classList.add('vjs-video');
        }
        videojs(el, {
            flvjs: {
                mediaDataSource: {
                    isLive: true,
                    cors: false,
                    withCredentials: false,
                },
            },
            controls: true,
            autoplay: false,
            preload: 'auto',
            fluid: false,
        });
    }
}

